export default [
  {
    title: 'Build on Domo',
    items: [
      {
        label: 'Overview',
        href: 'https://www.domo.com/platform/build',
      },
      {
        label: 'Docs & APIs',
        href: 'https://developer.domo.com',
      },
      {
        label: 'Start Building',
        href: 'https://developer.domo.com/dev-sandbox-request',
      },
    ],
  },
  {
    title: 'Partner Program',
    items: [
      {
        label: 'Overview',
        href: 'https://www.domo.com/partners/overview',
      },
      {
        label: 'Find a Partner',
        href: 'https://www.domo.com/partners/showcase#/',
      },
      {
        label: 'Get Started',
        href: 'https://www.domo.com/partners/overview#form',
      },
    ],
  },
  {
    title: 'Get Help',
    items: [
      {
        label: 'Support',
        href: 'https://www.domo.com/help-center',
      },
      {
        label: 'Community',
        href: 'https://dojo.domo.com',
      },
      {
        label: 'Knowledge Base',
        href: 'https://knowledge.domo.com',
      },
    ],
  },
  {
    title: 'Not a Developer',
    items: [
      {
        label: 'Pre-built Apps',
        href: 'https://www.domo.com/appstore',
      },
      {
        label: 'Domo Stories',
        href: 'https://www.domo.com/product/stories',
      },
      {
        label: 'Design Studio',
        href: 'https://developer.domo.com/docs/design-studio/app-overview',
      },
      {
        label: 'Work with Domo',
        href: 'https://www.domo.com/form/custom-solutions',
      },
    ],
  },
  {
    title: 'Learn More',
    items: [
      {
        label: 'Events',
        href: 'https://www.domo.com/company/events',
      },
      {
        label: 'Training',
        href: 'https://www.domo.com/university/training',
      },
    ],
  },
];
